import axiosInstance from './AxiosInstance';

/**
 * Obtiene el currículum del usuario autenticado
 * GET /jobs-my-resume
 */
export function getMyResume() {
    return axiosInstance.get('/jobs-my-resume');
}

/**
 * Crea o actualiza el currículum completo del usuario autenticado
 * PUT /jobs-my-resume
 * @param {Object} resumeData - Datos completos del currículum
 * @param {string} resumeData.resumen - Resumen del perfil
 * @param {Array<string>} resumeData.habilidades - Array de IDs de habilidades
 * @param {Array} resumeData.laboralExperiences - Array de experiencias laborales
 * @param {Array} resumeData.educations - Array de educaciones
 * @param {Array} resumeData.projects - Array de proyectos
 */
export function updateMyResume(resumeData) {
    return axiosInstance.put('/jobs-my-resume', resumeData);
}

/**
 * Sube un archivo PDF del currículum
 * POST /jobs-my-resume/upload-pdf
 * @param {File} file - Archivo PDF del currículum
 */
export function uploadResumePdf(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/jobs-my-resume/upload-pdf', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

/**
 * Obtiene el PDF del currículum por token
 * GET /jobs-my-resume/pdf/{token}
 * @param {string} token - Token único del PDF
 */
export function getResumePdf(token) {
    return axiosInstance.get(`/jobs-my-resume/pdf/${token}`, {
        responseType: 'blob',
        headers: {
            'Accept': 'application/pdf, */*',
        },
    });
}

